import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLangList } from '@/lib/i18n';
import { Dropdown, Avatar, Menu, message } from 'antd';
import { UserOutlined, BarcodeOutlined, LogoutOutlined } from '@ant-design/icons';
import Login from "@/config/login";
import User from "@/config/user";
import { cleanStorage, getStorage } from "@/lib/webStorage";
import { ModalProfile, ModalStudentCard, ModalChangePassword, ModalProfileTeacher } from "@/components/modal";
import { ReModal } from "@/components/refineElement";
import { getAccountInfo } from "@/stores/user/action";
import { getDetailsArray } from "@/lib/user";
import { dateFormat } from "@/lib/dateTime";
import { getOnOkFunction } from "@/lib/antdElementFunction";
import '@styles/profileToolbar.less';

const { logout } = Login;
const { changePassword, updateUserAccount, createUser } = User;

function ProfileToolbar() {
  const [isModalStudentCardVisible, clickModalStudentCard] = useState(false);
  const [isModalProfileVisible, clickModalProfile] = useState(false);
  const [isModalChangePasswordVisible, clickModalChangePassword] = useState(false);
  const [handleType, changeHandleType] = useState('');
  const { userInfo } = useSelector((state: any) => state.user);
  const roleId = +getStorage("roleId");
  const dispatch: any = useDispatch();
  const profileInfoT: any = getLangList("profileInfo");
  const errorT: any = getLangList("error");
  const errorCodeT: any = getLangList("errorCode");

  const openProfileUpdate = () => {
    getUserInfo();
    changeHandleType('update');
    clickModalProfile(!isModalProfileVisible);
  };

  const getUserInfo = () => {
    dispatch(getAccountInfo());
  };

  const updateUserInfo = (data: any) => {
    const {
      nameCn,
      nameEn,
      birthday,
      gender,
      residenceAddress,
      mailingAddress,
      identityNumber,
      school,
      grade,
      classroom,
      seatNumber,
      allergy,
      idCardImg,
      qrCode,
    } = data;
    const detailsArray = getDetailsArray(data);
    const basicInfo = {
      ...userInfo,
      nameCn,
      nameEn,
    };
    const studentInfo = {
      birthday: birthday?.format(dateFormat) ?? '',
      gender,
      residenceAddress,
      mailingAddress,
      identityNumber,
      school,
      grade,
      classroom,
      seatNumber,
      allergy,
      details: detailsArray,
    }
    const userInfoData = { ...basicInfo, ...studentInfo };
    delete userInfoData.idCard;
    delete userInfoData.qrCode;
    const params = { stringFormat: { userInfo: userInfoData }, fileFormat: { idCardImg, qrCode } };

    updateUserAccount(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorCodeT[res.errorCode] ?? errorT.failed);
      }
      message.success(errorT.success);
      changeHandleType('');
      clickModalProfile(!isModalProfileVisible);
    });
  }

  const createTeacherInfo = (values: any) => {
    const {
      nameCn,
      nameEn,
      idCardImg,
      qrCode,
      username,
      password,
    } = values;
    const userInfoData = {
      nameCn,
      nameEn,
      username,
      password,
      roleId: '1',
      details: [],
    };
    const params = { stringFormat: { userInfo: userInfoData }, fileFormat: { idCardImg, qrCode } };

    createUser(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorCodeT[res.errorCode] ?? errorT.failed);
      }
      message.success(errorT.success);
      changeHandleType('');
      clickModalProfile(!isModalProfileVisible);
    });
  }

  const updatePassword = (data: any) => {
    const { originPassword, newPassword, checkNewPassword } = data;
    const username = getStorage("account");
    const params = { originPassword, newPassword, checkNewPassword, username };

    changePassword(params).then((res: any) => {
      if (!res.success) {
        return message.error(errorT.failed);
      }
      message.success(errorT.success);
      clickModalChangePassword(!isModalChangePasswordVisible);
    });
  }

  const menu = (
    <Menu>
      <Menu.Item key={1}>
        <span onClick={openProfileUpdate}>{profileInfoT.PROFILE_INFO}</span>
      </Menu.Item>
      <Menu.Item key={2}>
        <span onClick={() => clickModalChangePassword(!isModalChangePasswordVisible)}>{profileInfoT.CHANGE_PASSWORD}</span>
      </Menu.Item>
    </Menu>
  );

  const clickLogout = () => {
    logout().then((res: any) => {
      res.success && afterLogout();
    });
  };

  const afterLogout = () => {
    cleanStorage();
  };

  const okFunction = {
    createUser: createTeacherInfo,
    update: updateUserInfo,
  };

  return (
    <div className="header-toolbar">
      <Dropdown overlay={menu} placement="bottomCenter" arrow trigger={['click']}>
        <div className="header-toolbar-item">
          <Avatar size="small" icon={<UserOutlined />} />
        </div>
      </Dropdown>

      <div className="header-toolbar-item" onClick={() => clickModalStudentCard(!isModalProfileVisible)}>
        <BarcodeOutlined />
      </div>

      <div className="header-toolbar-item" onClick={clickLogout}>
        <LogoutOutlined style={{ color: '#fff', transform: 'rotate(270deg)' }} />
      </div>

      {isModalStudentCardVisible &&
        <ReModal
          title={profileInfoT.STUDENT_CARD}
          onCancel={() => clickModalStudentCard(!isModalStudentCardVisible)}
          visible={true}
          onOk={() => clickModalStudentCard(!isModalStudentCardVisible)}
          CollectedForm={ModalStudentCard}
          width={'700px'}
          Footer={null}
        />
      }

      {isModalProfileVisible &&
        <ReModal
          title={profileInfoT.PROFILE_INFO}
          onCancel={() => clickModalProfile(!isModalProfileVisible)}
          visible={true}
          onOk={(data: any) => getOnOkFunction(handleType, data, okFunction)}
          CollectedForm={roleId === 2 ? ModalProfile : ModalProfileTeacher} // 2 為學生
          formProps={{
            getUserInfo: getUserInfo,
            handleType,
          }}
          width={'700px'}
        />
      }

      {isModalChangePasswordVisible &&
        <ReModal
          title={profileInfoT.CHANGE_PASSWORD}
          onCancel={() => clickModalChangePassword(!isModalChangePasswordVisible)}
          visible={true}
          onOk={updatePassword}
          CollectedForm={ModalChangePassword}
          width={'700px'}
        />
      }
    </div>
  )
}

export default ProfileToolbar;